<div [hidden]="sendMail">
  <div *ngIf="!ocultaField">
    <label [class.label-invalid]="!rota">Informe a rota</label>
    <div style="margin: 0px 0px 10px 0px;" class=" d-flex align-items-center input-group has-validations">
        <input class="form-control" aria-describedby="basic-question" type="text" placeholder=" " [disabled]="usuarioBloqueado" [(ngModel)]="rota" required/>

        <div class="input-group-append">
          <span class="input-group-text" id="basic-rota">
              <fa-icon class="float-end" [icon]="['fas', 'question']" size="lg"></fa-icon>
          </span>
        </div>
    </div>
  </div>

  <label *ngIf="!ocultaField" for="comboCdOrigem">
    <span [class.label-invalid]="!itemSelected.id">Informe o CD de origem (Nº Deposito)</span>
  </label>
  <div *ngIf="!ocultaField" class="input-group mb-3 ng-autocomplete">
    <ng-autocomplete 
        [data]="cdsOrigem"
        searchKeyword="name"
        [itemTemplate]="itemTemplate"
        [(ngModel)]="itemSelected"
        (inputChanged)='onChangeSearch($event)'
        [notFoundTemplate]="notFoundTemplate"
        [disabled]="usuarioBloqueado"
        placeholder='Pesquisar...'>                                 
    </ng-autocomplete>

    <ng-template #itemTemplate let-item>
        <a [innerHTML]="item.name"></a>
    </ng-template>
    
    <ng-template #notFoundTemplate let-notFound>
        <span>Nenhum registro encontrado</span>
    </ng-template>
  </div>

  <div class="container">
    <div class="row">
      <div class="col" style="padding: 0 !important">
        <div class="pb col next-button">
            <button type="button" class="btn btn-primary" [disabled]="!itemSelected.id || !rota || usuarioBloqueado" (click)="prosseguir()">
                PROSSEGUIR &nbsp;
                <fa-icon class="float-end" [icon]="['fas', 'arrow-circle-right']" size="lg"></fa-icon>
            </button>
        </div>
      </div>
    </div>
  </div>

</div>

<app-modal #modalCadastroViagem [(modalConfig)]="modalConfig">
  <span style="color: red;">
    CPF não possui SM para viagem, verifique os dados!
    <br/><br/>
    Deseja solicitar a geração da SM para seu CPF?
  </span>
</app-modal>

<app-modal #modalAtualizacaoViagem [(modalConfig)]="modalConfig">
  <span style="color: red;">CPF não confere com o cadastrado na rota, deseja realizar a atualização da SM com seu CPF?</span>
</app-modal>

<app-pre-checkout-viagem-send-mail *ngIf="sendMail"></app-pre-checkout-viagem-send-mail>